import {
	AccountManager,
	AccountManagerMock,
	AttestationManager,
	DAppsManager,
	DAppsManagerMock,
	EntitlementManager,
	EntitlementManagerMock,
	type NatsConnectionOptions,
	NatsMessagingAdapter,
	OnboardManager,
	OnboardManagerMock,
	ProjectsManager,
	ProjectsManagerMock,
	TeamsManager,
	TeamsManagerMock,
	TeamMembersManager,
	TeamMembersManagerMock
} from 'adapters'
import { Application } from 'core'
import { createState } from 'shared'

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle
let _application: Application

const IS_MOCK = process.env.TEST_ENV

const natsOptions: NatsConnectionOptions = {
	servers: 'wss://apiprod.codigohub.dev/authv2/ws/',
	pingInterval: 30 * 1000 // 30 seconds
}

if (!IS_MOCK) {
	const forManagingAccount = new AccountManager()
	const forManagingEntitlements = new EntitlementManager()
	const forManagingProjects = new ProjectsManager()
	const forOnboardingUser = new OnboardManager()
	const forManagingDApps = new DAppsManager()
	const forEventsMessaging = new NatsMessagingAdapter(natsOptions)
	const forAttestation = new AttestationManager()
	const forManagingTeams = new TeamsManager()
	const forManagingTeamMembers = new TeamMembersManager()

	_application = new Application({
		forManagingAccount,
		forManagingDApps,
		forManagingEntitlements,
		forManagingProjects,
		forOnboardingUser,
		forEventsMessaging,
		forAttestation,
		forManagingTeams,
		forManagingTeamMembers
	})
} else {
	const forManagingAccount = new AccountManagerMock()
	const forManagingEntitlements = new EntitlementManagerMock()
	const forManagingProjects = new ProjectsManagerMock()
	const forOnboardingUser = new OnboardManagerMock()
	const forManagingDApps = new DAppsManagerMock()
	const forEventsMessaging = new NatsMessagingAdapter(natsOptions)
	const forAttestation = new AttestationManager()
	const forManagingTeams = new TeamsManagerMock()
	const forManagingTeamMembers = new TeamMembersManagerMock()

	_application = new Application({
		forManagingDApps,
		forManagingAccount,
		forManagingEntitlements,
		forManagingProjects,
		forOnboardingUser,
		forEventsMessaging,
		forAttestation,
		forManagingTeams,
		forManagingTeamMembers
	})
}

const { state } = createState(_application)

export const application = state
